import { TipYourselfPage } from '@repo/ccc-main-app-lib/src/pages/TipYourselfPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/user/$userId/tip-yourself',
)({
  component: UserTipYourselfPage,
})

function UserTipYourselfPage() {
  const { userId } = Route.useParams()

  return <TipYourselfPage userId={userId} />
}
